module.exports = __webpack_public_path__ + "img/notice.9a892114.png";